import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../services/api';

export default function TrialRedeemRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (!token) return navigate('/pricing');
        // Check token availability (public)
        const resp = await ApiService.get(`/trial/info/${encodeURIComponent(token)}`);
        const available = resp?.available || resp?.data?.available;
        if (!mounted) return;
        if (available) {
          // Do NOT persist token in localStorage/cookies. Simply redirect with token in URL.
          const qs = [];
          qs.push(`trial=true`);
          qs.push(`trialToken=${encodeURIComponent(token)}`);
          const qsNow = new URLSearchParams(location.search || '');
          const sig = qsNow.get('sig') || qsNow.get('Sig') || null;
          if (sig) qs.push(`sig=${encodeURIComponent(sig)}`);
          const loc = qsNow.get('locationId') || qsNow.get('location') || qsNow.get('locationid');
          if (loc) qs.push(`location=${encodeURIComponent(loc)}`);
          const source = qsNow.get('source') || qsNow.get('utm_source') || null;
          if (source) qs.push(`source=${encodeURIComponent(source)}`);
          navigate(`/trial-landing?${qs.join('&')}`, { replace: true });
        } else {
          // invalid or used/expired token - still go to pricing but show no trial
          navigate('/pricing?trial=false', { replace: true });
        }
      } catch (err) {
        console.error('Trial redirect failed', err);
          navigate('/pricing?trial=false', { replace: true });
      }
    })();

    return () => { mounted = false; };
  }, [token, navigate]);

  return null;
}
